import script from "./AllPersonalitiesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AllPersonalitiesPage.vue?vue&type=script&setup=true&lang=js"

import "./AllPersonalitiesPage.vue?vue&type=style&index=0&id=4439f534&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4439f534"]])

export default __exports__